// src/components/Modal.tsx

import React from "react";
import { Modal as MuiModal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
}

// Estilo ajustado para ser responsivo e suportar rolagem interna
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // --- Ajustes de Responsividade ---
  // Largura máxima em telas pequenas (xs) para ocupar quase toda a tela
  width: "90%",
  // Largura definida em telas médias (sm) e maiores
  maxWidth: 600,
  // Altura máxima para evitar que o modal seja maior que a tela
  maxHeight: "90vh", // 90% da altura da viewport
  // Adiciona rolagem vertical caso o conteúdo exceda o maxHeight
  overflowY: "auto",

  // Estilos visuais
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, title }) => {
  return (
    <MuiModal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        {/* Header do Modal */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            // Importante: Fixa o header no topo do modal para que ele não role junto com o conteúdo
            // Esta é uma melhoria de UX, garantindo que o título e o botão de fechar estejam sempre visíveis.
            position: "sticky",
            top: 0,
            bgcolor: "background.paper", // Garante que o fundo seja opaco
            zIndex: 1, // Garante que o header fique acima do conteúdo
            pt: 0, // Remove padding superior do header (já está no p: 4 do style)
            mx: -4, // Compensa o padding horizontal do Box pai para esticar o fundo
            px: 4,
          }}
        >
          <Typography id="modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <IconButton onClick={onClose} aria-label="fechar">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Conteúdo do Modal (o formulário) */}
        {/* O conteúdo rola se for maior que a tela */}
        <div id="modal-description">{children}</div>
      </Box>
    </MuiModal>
  );
};

export default Modal;
